
const Errormsg = (props) => (
  <div className="alert alert-danger">
     {props.message}
  </div>
)

export default Errormsg